import React from 'react';
import { CloudIcon, GraphIcon, GearIcon, BarChartIcon, RocketIcon } from '../components/Icons';

const ACCELERATORS = [
  {
    icon: <CloudIcon />, tag: 'SAP BTP', stat: '60% faster',
    title: 'SAP BTP Integration Framework',
    desc: 'Reusable iFlow templates, security patterns, error handling and monitoring standards for SAP BTP projects.',
    items: ['30+ pre-built iFlow templates', 'OAuth / JWT security patterns', 'Centralized error handling', 'Alert & monitoring dashboards', 'Documentation standards', '~60% faster new project delivery'],
  },
  {
    icon: <GraphIcon />, tag: 'Governance', stat: '100% governed',
    title: 'API Governance Toolkit',
    desc: 'Standards, templates and automation for API naming, versioning, lifecycle management and developer documentation.',
    items: ['Naming & versioning standards', 'OpenAPI 3.0 templates', 'API lifecycle workflows', 'Developer portal templates', 'Security & access control', 'Automated documentation'],
  },
  {
    icon: <GearIcon />, tag: 'Odoo', stat: '55% faster ops',
    title: 'Odoo CRM Templates',
    desc: 'Pre-built Odoo workflows for customer operations: case management, payments, disputes and knowledge-base.',
    items: ['Case management workflows', 'Payment dispute automation', 'Customer portal templates', 'Escalation rule library', 'SLA tracking dashboards', 'Knowledge base integration'],
  },
  {
    icon: <BarChartIcon />, tag: 'Analytics', stat: '12 templates',
    title: 'Analytics Dashboard Starter Kit',
    desc: 'Ready-to-use Power BI templates for manufacturing, finance, sales and operations KPI reporting.',
    items: ['12 pre-built dashboard layouts', 'Manufacturing OEE templates', 'Finance P&L / cashflow', 'Sales pipeline analytics', 'Automated refresh config', 'Drill-through navigation'],
  },
  {
    icon: <RocketIcon />, tag: 'AI Tools', stat: '70% less manual',
    title: 'AI-Assisted Migration Utility',
    desc: 'LLM-powered code parsing, interface mapping and documentation generation for legacy integration modernization.',
    items: ['WSDL / SOAP parser', 'Auto REST mapping generation', 'OpenAPI documentation output', 'Test case generation', 'Human review workflow', '70% reduction in manual effort'],
  },
];

export default ACCELERATORS;
